var map = {
	"./culinary-logo.png": 744,
	"./hero.mp4": 672,
	"./hero.png": 247,
	"./r1.jpg": 620,
	"./r2.jpg": 331,
	"./r3.jpg": 198,
	"./r4.jpg": 277,
	"./r5.jpg": 56,
	"./r6.jpg": 55
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 463;